module.exports = __webpack_public_path__ + "media/pl.562edca5.svg";